<template>

  <div style="border: 1px solid #dedede;width: 95%;margin: 0 auto; display: block;">
    <div style="margin-left: 10px;color: #939393">序列号信息</div>
    <frame-form ref="after_sales_select_sn" component-param="after_sales_select_sn" :readonly="isDisable"
                :parent-data="{company_id:companyId}" ></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">产品明细</div>
    <frame-form ref="crm_asset_product_manage" style="padding-left: 100px"
                :parent-data="productDetail" component-param="crm_asset_product_manage" :readonly="true"></frame-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">停用信息</div>
    <el-form>
      <el-row>
        <el-col :span="11">
          <el-form-item label="停用日期：" label-position="right" label-width="150px">
            <el-date-picker v-model="deactivate_date" :disabled="isDisable"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：" label-position="right" label-width="150px">
            <el-input v-model="deactivate_remark" style="width: 100%" :disabled="isDisable" type="textarea" rows="3" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>

  <div style="border: 1px solid #dedede;width: 95%;display: block;margin: 10px auto 0;">
    <div style="margin-left: 10px;color: #939393">关联信息</div>
    <el-form>
      <el-row>
        <el-col :span="11">
          <el-form-item label="机会编号：" label-position="right" label-width="150px">
            <el-select v-model="chance_id" @change="getContractList" :disabled="isDisable">
              <el-option v-for="item in chanceList" :key="item.id" :label="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="合同编号：" label-position="right" label-width="150px">
            <el-select v-model="contract_no" :disabled="isDisable" clearable>
              <el-option v-for="item in contractList" :key="item.contract_no" :label="item.contract_no" :value="item.contract_no"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：" label-position="right" label-width="150px">
            <el-input v-model="remark" style="width: 100%" :disabled="isDisable" type="textarea" rows="3" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div v-if="!isDisable" style="margin: 10px 0 50px 0;text-align: center"><el-button type="primary" style="width: 150px" @click="saveData" >保存</el-button></div>

</template>

<script>
export default {
  name: "StopUsingSnOperate",
  inject: ['$fn'],

  props: {
    companyId: {
      type: String,
      required: true
    },
    isDisable:{
      type: Boolean,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  provide() {
    return {
      $fn: {
        initProduct: () => {
          this.initProductDetail();
        }
      }
    }
  },

  watch: {
    companyId(value) {
      if(value){
        this.getChanceList(value);
        this.$refs.after_sales_select_sn.initForm();
      }else {
        this.chance_id = '';
        this.chanceList = [];
      }
    }
  },

  data() {
    return {
      chanceList: [],
      contractList:[],
      chance_id:'',
      contract_no:'',
      remark:'',
      productDetail:{
        detail_list:[],
      },
      deactivate_date:'',
      deactivate_remark:'',

    }
  },
  created() {
    this.getChanceList(this.companyId);
  },

  mounted() {
    this.initData();
  },

  methods: {
    async getChanceList(company_id){
      if(!company_id){
        return;
      }
      this.chanceList = await this.$http('assetService.getChanceListByCompany',{company_id:company_id});
    },
    async getContractList(){
      this.contractList = await this.$http('assetService.getContractListByChance',{chance_id:this.chance_id});
    },

    async saveData(){
      if(!this.chance_id){
        this.$message.error('机会编号为空');
        return;
      }
      // if(!this.contract_no){
      //   this.$message.error('合同编号为空');
      //   return;
      // }
      if(!this.companyId){
        this.$message.error('公司为空');
        return;
      }

      let data = await this.$refs.after_sales_select_sn.formInfo;
      let checkResult = this.checkSelectSnInfo(data);
      if(!checkResult){
        return;
      }

      let params = {
        company_id:this.companyId,
        chance_id:this.chance_id,
        contract_no:this.contract_no,
        remark:this.remark,
        operate:'stop_using',
        deactivate_date:this.deactivate_date,
        deactivate_remark:this.deactivate_remark,
        sn_info:data,
        product_info:this.productDetail.detail_list,
      }

      this.$http('assetService.stopUsingSnOperate', params).then(() => {
        this.$message.success("操作成功");
        this.$fn.closeWindow();
        this.$fn.search();
      })


    },


    async initProductDetail() {
      let snInfo = this.$refs.after_sales_select_sn.formInfo;
      let productList = await this.$http('assetService.getProductItemBySn', {serial_number: snInfo.serial_number});
      this.productDetail.detail_list = [];
      for (let product of productList) {
        let item = {
          nanoid: product.id,
          product_id: product.product_id,
          cnt: product.cnt,
        }
        this.productDetail.detail_list.push(item);
      }
      this.$refs.crm_asset_product_manage.mergeFormData(this.productDetail);
      let snData = await this.$http('assetService.getAssetInfoBySn',{serial_number: snInfo.serial_number});
      this.chance_id = snData.chance_id;
      await this.getContractList();
      this.contract_no = snData.contract_no;
    },


    checkSelectSnInfo(data){
      let serialNumber = data.serial_number;
      if(!serialNumber){
        this.$message.error('未选择停用序列号');
        return false;
      }
      return true;
    },


    initData(){
      if(this.isDisable){
        let data = this.parentData;
        let otherContent = JSON.parse(data.other_content);
        let snInfoBefore = JSON.parse(data.sn_info_before);
        let productInfo = JSON.parse(data.product_info_before);

        this.chance_id = otherContent.chance_id;
        this.contract_no = otherContent.contract_no;
        this.remark = otherContent.remark;
        this.deactivate_date = otherContent.deactivate_date;
        this.deactivate_remark = otherContent.deactivate_remark;

        setTimeout(() => {
          this.$refs.after_sales_select_sn.mergeFormData(snInfoBefore);
          let productData = {
            detail_list: productInfo,
          }
          this.$refs.crm_asset_product_manage.mergeFormData(productData);
        },2000);
      }
    }

  }
}
</script>

<style scoped>

</style>